<template>
    <div @dblclick="toggleEditable">
         <span v-if="isEditable">
            <select class="border rounded-md" @change="handleInputChange" :value="clientContact.is_primary_contact" name="" id="">
                <option v-for="option in selectOptions" :key="option.value" :value="option.value">{{ option.label }}</option>
            </select>
        </span>
        <span v-else >{{ clientContact.is_primary_contact }}</span>
    </div>
</template>

<script setup>
import {ref, computed, defineProps, defineEmits, watch} from "vue";
import {updateContactClientRelationship} from '@/services/Contact.js'
import { useStore } from "vuex";

  const isEditable = ref(false)

  const store = useStore()

  const props = defineProps(['clientContact'])

  const emit = defineEmits(['refetch-clients'])

  function fetchNewClients () {
      emit('refetch-clients')
  }

  function toggleEditable () {
      isEditable.value = !isEditable.value
  }

  const selectOptions = ref([
    {value: false, label: "False"},
    {value: true, label: "True"}
  ])

  const contactFirstName = computed(() => {
    return props.clientContact.first_name ? props.clientContact.first_name : "--"
  })

  async function handleInputChange(e) {
            let newValue = e.target.value
            const targetField = "is_primary_contact"
            let updatedData = {}
            updatedData[targetField] = newValue
            const data = JSON.stringify(updatedData);
            console.log('data', data)
            let token = store.state.auth.token
            console.log('new value', newValue)
            await updateContactClientRelationship(props.clientContact.id, data, token)
            emit('refetch-clients')
            isEditable.value = false

        }

</script>